import React from "react";
import SelectField from "../../../../components/SelectField";
import MultiSelect from "../../../../components/MultiSelect";
import styles from "./index.module.scss";
import { SeminarFormProps } from "../types";

const SeminarForm: React.FC<SeminarFormProps> = ({
    seminar,
    index,
    state,
    sessionsList,
    onSeminarChange,
    onSessionChange,
    onRemoveSeminar,
    getFilteredOptionsForSection
}) => {
    return (
        <div className={`${styles.section} mb-3`}>
            <h2>Related Seminars & Sessions</h2>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="col-12 col-md-10">
                    <SelectField
                        label="Seminar Name"
                        name="seminarName"
                        options={getFilteredOptionsForSection(seminar.seminarId || "").map((seminar) => ({ 
                            label: seminar.event.eventTitle, 
                            value: seminar.event.eventTitle 
                        }))}
                        value={seminar.SeminarTitle || ""}
                        onChange={(_, value) => onSeminarChange(value, index)}
                        minHeight={55}
                    />
                </div>
                <button
                    type="button"
                    onClick={() => onRemoveSeminar(null, index)}
                    className={styles.clearButton}
                >
                    Clear
                </button>
            </div>

            {(state.seminars && state.seminars.length > 0 && seminar.seminarId) && (
                <div className="col-12 col-md-10">
                    <MultiSelect
                        label="Sessions"
                        options={sessionsList && sessionsList
                            .filter(session => session && session.sessionTitle && session._id && session.eventId === seminar.seminarId)
                            .map((session) => ({
                                label: session.sessionTitle,
                                value: session._id
                            })) || []}
                        value={state.sessions ? state.sessions.filter(s => s && s.sessionId && s.seminarId === seminar.seminarId).map(s => s.sessionId) : []}
                        name="sessions"
                        onChange={(name, selectedSessionIds) => onSessionChange(name, selectedSessionIds, seminar.seminarId || "")}
                        placeholder="Select sessions..."
                        minHeight={55}
                    />
                </div>
            )}
        </div>
    );
};

export default SeminarForm;
